import { Card } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { TimesheetProvider } from "../../contexts";
import { formatEntryPerActivityByDays } from "../../utils";
import { EditableTimesheet } from "../editable-timesheet";
import { HoursNotification } from "../hours-notification";
import { NonEditableTimesheet } from "../non-editable-timesheet";
import { TimesheetTimeline } from "../timesheet-timeline";
import { Text_One,Text_Two } from "./textconstant";
import { countryList } from "utils/country-list";
import { COUNTRY_VALUE } from "../timesheet-timeline/constants";
export const Timesheet = ({
  editable = true,
  footer = null,
  timesheet: defaultTimesheet,
  weekInfo = [],
  dayTargetHours,
  pdCommentShown,
  tableTitle,
  columns,
  disabledActivities,
  ModalType,
  ContractType
}) => {
  const { days, loading } = useSelector((state) => state.timesheet);
  const timesheetSettingsLoading = useSelector((state) => state.timesheetSettings.loading);
  const Find_Country=useSelector((state)=>state.appConfiguration.entityCode)
  const [timesheet, setTimesheet] = useState(defaultTimesheet);
  const storeTimesheet = useSelector((state) => state.timesheet.timesheet);

  useEffect(() => {
    if (days?.days) {
      setTimesheet(
        defaultTimesheet
          ? {
              ...defaultTimesheet,
              timeSheetEntryPerActivities: defaultTimesheet.timeSheetEntryPerActivities.map((entryPerActivity) => ({
                ...entryPerActivity,
                dayActivityLinks: formatEntryPerActivityByDays(days.days, entryPerActivity.dayActivityLinks)
              }))
            }
          : null
      );
    }
  }, [defaultTimesheet, days?.weekId]);

  useEffect(() => {
    if (days?.days) {
      setTimesheet(
        storeTimesheet && {
          ...storeTimesheet,
          timeSheetEntryPerActivities: storeTimesheet.timeSheetEntryPerActivities.map((entryPerActivity) => ({
            ...entryPerActivity,
            projectId: entryPerActivity.project.id,
            activityCascader: [entryPerActivity.subproject.id, entryPerActivity.activity.id],
            activityId: entryPerActivity.activity.id,
            dayActivityLinks: formatEntryPerActivityByDays(days.days, entryPerActivity.dayActivityLinks)
          }))
        }
      );
    }
  }, [storeTimesheet]);

  const isTimesheetEditable =
    typeof editable === "boolean" ? editable : typeof editable === "function" ? (() => editable(timesheet))() : false;

  const isPdCommentShown =
    typeof pdCommentShown === "boolean"
      ? pdCommentShown
      : typeof pdCommentShown === "function"
      ? (() => pdCommentShown(timesheet))()
      : false;

  disabledActivities =
    typeof disabledActivities === "function" ? disabledActivities(timesheet) : disabledActivities || [];

   
  return (
    <>
      <TimesheetProvider
        defaultTimesheet={defaultTimesheet}
        timesheet={timesheet}
        setTimesheet={setTimesheet}
        weekInfo={weekInfo}
        dayTargetHours={dayTargetHours}
        pdCommentShown={isPdCommentShown}
        disabledActivities={disabledActivities}
      >
        <Card
          title={<TimesheetTimeline />}
          extra={<HoursNotification ModalType={ModalType} ContractType={ContractType} />}
        >
          {isTimesheetEditable ? (
            <EditableTimesheet
              tableTitle={tableTitle}
              days={days?.days}
              loading={loading || timesheetSettingsLoading}
              columns={columns}
            />
          ) : (
            <NonEditableTimesheet
              tableTitle={tableTitle}
              timesheetEntries={timesheet?.timeSheetEntryPerActivities || []}
              loading={loading || timesheetSettingsLoading}
            />
          )}
          {footer}
        </Card>
        {Find_Country==COUNTRY_VALUE.INDIA && (
          <Card>
          <div>
            <p className="Text_on_Dashboard">Note: -</p>
            <p>{Text_One}</p>
            <p>{Text_Two}</p>
          </div>
        </Card>
        )}
      </TimesheetProvider>
    </>
  );
};
